// PACKAGES
import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useContext } from 'use-context-selector'
import styled from 'styled-components'
// UI
import { Grid, Container, CircularProgress } from '@material-ui/core'
// COMPONENTS
import ApplicationCompleteCards from './ApplicationCompleteCards'
import ApplicationIncompleteCard from './ApplicationIncompleteCard'
import TrackingPixel from '../Utility/TrackingPixel'
// CONTEXTS
import { AnswerContext } from '../../contexts/AnswerContext'
// CONFIG
import { legacyApplyURL } from '../../config'
// CONSTS
import { TRACKING_FINISH, TRACKING_SUBMIT } from '../../util/consts'
// SERVICES
import PostingsService from '../../services/postings'
import ProfileService from '../../services/profile'

const SuccessGrid = styled(Grid)`
  min-height: 100vh;
  text-align: center;
`

const Success = ({ postingDetails: { clientId, clientName, location: { id: locationId }, url }, postingId }) => {
  const [answerContext] = useContext(AnswerContext)

  const [additionalSteps, setAdditionalSteps] = useState(null)

  const location = useLocation()

  const getProfileValue = key => answerContext[`profile-${key}`] ? answerContext[`profile-${key}`].value : null

  const email = getProfileValue('email')
  const phone = getProfileValue('phone')
  const path = ProfileService.parseApplyUrl(url)
  const username = email || phone || ''

  const sendToLegacyApplication = () => {
    window.location.replace(legacyApplyURL + path + location.search)
  }

  useEffect(() => {
    PostingsService.getAdditionalSteps(clientId, locationId, postingId).then(
      response => setAdditionalSteps(response || [])
    )
  }, [clientId, locationId, postingId])

  const renderSuccessCards = () => {
    return additionalSteps.length
      ? <ApplicationIncompleteCard clientName={clientName} nextSteps={additionalSteps} onComplete={sendToLegacyApplication} />
      : <ApplicationCompleteCards clientName={clientName} username={username} />
  }

  const noAdditionalSteps = Array.isArray(additionalSteps) && !additionalSteps.length

  return (
    <>
      <Container maxWidth='sm'>
        <SuccessGrid
          container
          direction='column'
          justifyContent='center'
          alignItems='stretch'
          spacing={4}
        >
          <Grid item xs={12} />
          {Array.isArray(additionalSteps)
            ? renderSuccessCards(additionalSteps)
            : <Grid item xs={12}><CircularProgress aria-label='Submitting Application' /></Grid>}
        </SuccessGrid>
      </Container>
      {noAdditionalSteps && <TrackingPixel eventName={TRACKING_FINISH} />}
      <TrackingPixel eventName={TRACKING_SUBMIT} />
    </>
  )
}

export default Success
